import { Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { useTranslation } from 'react-i18next'
import { Input, Row, Col } from 'antd'
import Wrapper from 'components/reusables/wrapper'
import { SelectTypeProfile } from 'components/configuration/components/lms-profiles/fields'
import { ProfileRoutes } from 'enum/routes'
import { ColorPicker } from 'components/reusables/colorPicker'
import { Title, Subtitle, Label } from './styled'
import { CreateProfileProvider, useCreateProfile } from './context'
import { Buttons, ProfileTypes } from './components'

const CreateProfile = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { control } = useCreateProfile()
  const translationPrefix = 'configuration.lmsProfiles'

  return (
    <Wrapper shadow>
      <Title>
        <FontAwesomeIcon
          onClick={() => history.push(ProfileRoutes.MAIN)}
          icon={faArrowLeft}
        />
        {t(`${translationPrefix}.create.title`)}
      </Title>
      <Subtitle>{t(`${translationPrefix}.create.subtitleV2`)}</Subtitle>
      <Row gutter={24}>
        <Col span={12}>
          <Label>{t(`${translationPrefix}.form.name`)}</Label>
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <Input
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                size="large"
              />
            )}
          />
        </Col>
        <Col span={12}>
          <Label>{t(`${translationPrefix}.form.colorV2`)}</Label>
          <Controller
            control={control}
            name="color"
            render={({ field }) => (
              <ColorPicker value={field.value} onChange={field.onChange} />
            )}
          />
        </Col>
      </Row>
      <Controller
        control={control}
        name="profileType"
        render={({ field }) => (
          <SelectTypeProfile
            value={field.value}
            onChange={(type) => field.onChange(type)}
          />
        )}
      />
      <Controller
        control={control}
        name="profileType"
        render={({ field }) => <ProfileTypes value={field.value} />}
      />
      <Buttons />
    </Wrapper>
  )
}

export default () => (
  <CreateProfileProvider>
    <CreateProfile />
  </CreateProfileProvider>
)
